import React, { Component } from "react";
import MessageApi from "../../../api/Message";
import Spinner from "../../Common/Spinner";
import "./FilesWindow.css";
import "./Sidebar.css";
import FilePreview2 from "../../FilePreview2";
import Loader from "../../Common/Loader";
import util from "../../../helper/util";
import pdfLogo from "../../../assets/images/pdf.png";
import { Document, Page } from "react-pdf";
import _ from "lodash";
import Sidebar from "./Sidebar";
import Draggable from "./Draggable";
import Notify from "../../Common/Notify";
import { ToastContainer } from "react-toastify";
import {
  fetchDocuments,
  saveDocument,
  fetchFilteredDocuments,
  categorizeDocument,
} from "../../../actions/DocumentAction";
import { connect } from "react-redux";
import FilePreview from "../../FilePreview";
import ReactTooltip from "react-tooltip";
import ImageLoad from "../../Common/ImageLoad";
import ImagePlaceholder from "../../Common/ImagePlaceholder";
import config from "../../../config";
import { parseAction } from "../../../actions/REST";
import { getFilesv3 } from "../../../actions/ThreadAction";

class FilesWindow extends Component {
  constructor(props) {
    super(props);

    const { threadId } = this.props;

    this.state = {
      threadId,
      messages: [],
      hasScrolled: false,
      monthYears: [],
      grouped: {},
      attachmentId: "",
      isTagging: false,
      isloading: false,

      // Category filtering
      categoryFilter: "",
      category: {
        label: "All files",
        dropzoneRef: "",
      },
      documents: [],
      documentsFiles: [],
      currentDocumentsIndex: 1,
      documentPreviewShown: false,

      // Pagination
      page: 0,
      size: 20,
      total: 0,
      hasMore: true,

      // Modal
      modalShown: false,
      currentIndex: 1,
      files: [],

      // Loading
      isLoading: true,
      loadingMessage: "Loading files. Please wait...",
      isLoadingInitial: true,
      sidebarShown: false,
    };

    this.headerStyles = {
      boxShadow: "grey 0px 0px 8px -2px",
      position: "relative",
      width: "100%",
      background: "white",
      zIndex: "1",
      padding: "10px",
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.openModal = this.openModal.bind(this);

    // constants
    this.links = this.getLinks();
  }

  componentDidMount() {
    const { threadId, page, size } = this.state;

    // this.props.fetchFilteredDocuments(threadId, "", 0, 20)
    //   .then((res) => {
    //     const { document, hasMore } = res;

    //     this.organizeFiles(document, hasMore, 0);
    //     this.setState({ isLoadingInitial: false });
    //   });

    this.getFiles(threadId, { page, size })
      .then(() => {
        this.setState({ isLoadingInitial: false });
      })
      .catch(() => {
        this.setState({ isLoadingInitial: false });
      });

    // Handle scrolling
    const scrollableContent = document.getElementById("main-row-wrapper");

    scrollableContent.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    const scrollableContent = document.getElementById("main-row-wrapper");

    scrollableContent.removeEventListener("scroll", this.handleScroll);
  }

  async getFiles(threadId, options = {}) {
    this.setState({ isLoading: true });

    try {
      // const result = await MessageApi.getFilesv2(threadId, {
      const result = await this.props.getFilesv3(threadId, {
        page: options.page,
        size: options.size,
      });

      const withoutNull = result.files.filter((f) => !!f);

      const newMessages = withoutNull.map((message) => {
        const fileType = util.detectType(message.fileType);
        const monthYear = util.getMonthYear(message.createdAt);

        return {
          ...message,
          fileType,
          monthYear,
        };
      });

      const grouped =
        options.page == 0
          ? _.groupBy([...newMessages], "monthYear")
          : _.groupBy([...this.state.messages, ...newMessages], "monthYear");

      const newFiles = newMessages.map((message) => {
        const fileType = util.detectType(message.fileType);

        return {
          ...message.file,
          fileType,
          messageObjectId: message.objectId,
          thumbUrl: message.thumbnail ? message.thumbnail.url : "",
        };
      });

      this.setState({
        isLoading: false,
        hasMore: result.hasMore,
        page: result.page,
        size: result.pageSize,

        messages: [...this.state.messages, ...newMessages],
        files: [...this.state.files, ...newFiles],
        grouped,
      });
    } catch (err) {
      console.error(err);

      this.setState({ isLoading: false });

      alert("Could not fetch files");
    }
  }

  getFileType(message) {
    if (message.video) {
      return "video";
    }
    // It might be a PDF, because...
    // becase why not? Hahaha
    else if (message.picture) {
      const { url } = message.picture;

      const fileExt = util.getFileExtension(url);

      const isPDF = fileExt === "pdf";

      return isPDF ? "pdf" : "image";
    } else {
      return "image";
    }
  }

  loadMore() {
    const { threadId, categoryFilter, page, size } = this.state;

    if (this.state.categoryFilter != "") {
      this.props.fetchFilteredDocuments(threadId, categoryFilter, page + 1, size).then((res) => {
        const { document, hasMore } = res;

        this.organizeFiles(document, hasMore, page + 1);
      });
    } else {
      // old api - for all files
      this.getFiles(threadId, { page: page + 1, size }).then(() => {
        this.setState({ hasScrolled: false });
      });
    }
  }

  organizeFiles(document, hasMore, page) {
    var withoutNull = document.filter((f) => !!f);

    const newMessages = withoutNull.map((message) => {
      const fileType = util.detectType(message.attachment.fileType);
      const monthYear = util.getMonthYear(message.attachment.createdAt);

      return {
        ...message,
        fileType,
        monthYear,
      };
    });

    const grouped =
      page === 0
        ? _.groupBy([...newMessages], "monthYear")
        : _.groupBy([...this.state.messages, ...newMessages], "monthYear");

    const newFiles = newMessages.map((message) => {
      const fileType = util.detectType(message.attachment.fileType);

      return {
        ...message.attachment.file,
        fileType,
        messageObjectId: message.attachment.objectId,
        thumbUrl: message.attachment.thumbNail ? message.attachment.thumbNail.url : "",
      };
    });

    const files = page === 0 ? [...newFiles] : [...this.state.files, ...newFiles];

    this.setState({
      isLoading: false,
      hasMore: hasMore,
      page: page,
      size: 20,

      messages: [...this.state.messages, ...newMessages],
      files: files,
      grouped,

      hasScrolled: false,
    });
  }

  handleScroll(event) {
    let initialHeight = event.target.scrollHeight;
    let height = event.target.offsetHeight;
    let scrollTop = event.target.scrollTop;

    // Consider scrolled to bottom even if 10 pixels before
    const offset = 10;

    if (scrollTop + height >= initialHeight - offset) {
      const { isLoading, hasScrolled, hasMore } = this.state;

      if (!isLoading && hasScrolled === false && hasMore) {
        setTimeout(() => {
          this.setState({ hasScrolled: true });
          this.loadMore();
        }, 0);
      }
    }
  }

  handleModalClose() {
    this.setState({ modalShown: false });
  }

  openModal(objectId) {
    const { files = [] } = this.state;

    const index = files.findIndex((f) => f.messageObjectId === objectId);

    this.setState({
      currentIndex: index + 1,
      modalShown: true,
    });
  }

  setLoading(boolean, message) {
    this.setState({
      isLoading: boolean,
      loadingMessage: message,
    });
  }

  closeDocument() {
    this.setState({ sidebarShown: false });
  }

  openDocument() {
    this.setState({ sidebarShown: true });
  }

  clodeDocument() {}

  toggleSidebar() {
    const { sidebarShown } = this.state;

    this.setState({ sidebarShown: !sidebarShown });
  }

  handleDrag() {
    this.openDocument();
  }

  handleFilter(filter) {
    this.setState({ isLoading: true });
    const { threadId } = this.state;

    const category = this.links.find((link) => {
      return link.dropzoneRef === filter;
    });

    this.setState({
      category,
      categoryFilter: filter,
    });

    if (filter === "") {
      const { threadId } = this.state;
      const page = 0;
      const size = 20;
      this.getFiles(threadId, { page, size });
    } else {
      this.props.fetchFilteredDocuments(threadId, filter, 0, 20).then((res) => {
        const { document, hasMore } = res;

        this.organizeFiles(document, hasMore, 0);
      });
    }
  }

  handleTagging() {
    this.setState({ isTagging: !this.state.isTagging });
    this.openDocument();
  }

  handleMouseDown = (message) => {
    this.openDocument();
    console.log("trigger mouse down:", message);
    this.setState({ attachmentId: message.attachmentId });
  };

  handleTaggingDocs(e, emrType, message) {
    e.preventDefault();
    this.setState({ isloading: true });

    this.props.categorizeDocument(this.state.threadId, emrType, message.attachmentId).then((res) => {
      if (res.message == "Document categorized.") Notify.success(res.message);
      this.setState({ isloading: false });

      message.emrType = emrType;
    });
  }

  // no longer use
  fetchDocuments(threadId, filter) {
    this.setLoading(true, "Fetching documents");

    this.props
      .fetchDocuments(threadId, filter, true)
      .then((documents) => {
        this.setLoading(false);

        const documentsFiles = this.formatFiles(documents);

        this.setState({
          documents,
          documentsFiles,
        });
      })
      .catch((err) => {
        this.setLoading(false);
        console.error(err);
        alert("Failed to fetch");
      });
  }

  formatFiles(documents = []) {
    return documents.map((item, i) => {
      if (item.photo) {
        if (item.photo.url) {
          let fileExt = util.getFileExtension(item.photo.name);
          if (fileExt === "pdf") {
            return {
              objectId: item.objectId,
              url: item.photo.url,
              isPDF: true,
              user: item.user,
              originalSender: item.originalSender,
              date: item.createdAt,
              originalDateSent: item.originalDateSent,
            };
          }
          return {
            objectId: item.objectId,
            url: item.photo.url,
            isIMG: true,
            user: item.user,
            originalSender: item.originalSender,
            date: item.createdAt,
            originalDateSent: item.originalDateSent,
          };
        }
      }
      return null;
    });
  }

  getLinks() {
    const links = [
      {
        dropzoneRef: "encounter_notes",
        label: "MD Notes",
        imageSrc: require("../../../assets/images/notepad.png"),
      },
      {
        dropzoneRef: "meds_rx",
        label: "Meds/Rx",
        imageSrc: require("../../../assets/images/medicine.png"),
      },
      {
        dropzoneRef: "authorization",
        label: "Auths",
        imageSrc: require("../../../assets/images/copyright.png"),
      },
      {
        dropzoneRef: "labs",
        label: "Labs",
        imageSrc: require("../../../assets/images/laboratory.png"),
      },
      {
        dropzoneRef: "radiology",
        label: "Xrays/scans",
        imageSrc: require("../../../assets/images/x-ray.png"),
      },
      // { dropzoneRef: 'pathology', label: 'Pathology', imageSrc: require('../../../assets/images/bacteria.png') },
      // { dropzoneRef: 'consult_notes', label: 'MD Specialist Notes', imageSrc: require('../../../assets/images/notepad.png') },
      {
        dropzoneRef: "hospital_records",
        label: "Hospital files",
        imageSrc: require("../../../assets/images/medical-history.png"),
      },
      {
        dropzoneRef: "photos",
        label: "Photos",
        imageSrc: require("../../../assets/images/photos.png"),
      },
      {
        dropzoneRef: "admin_docs",
        label: "Admin/Legal",
        imageSrc: require("../../../assets/images/case.png"),
      },
      {
        dropzoneRef: "other_files",
        label: "Other",
        imageSrc: require("../../../assets/images/papers.png"),
      },
    ];

    return links;
  }

  handleOpenDocument(objectId) {
    const { documentsFiles = [] } = this.state;

    const index = documentsFiles.findIndex((f) => f.objectId === objectId);

    this.setState({
      currentDocumentsIndex: index + 1,
      documentPreviewShown: true,
    });
  }

  closeDocumentPreview() {
    this.setState({
      documentPreviewShown: false,
    });
  }

  handleSelectDocument(link) {
    const { messages, currentIndex } = this.state;

    const document = messages[currentIndex - 1];

    const supportedFileTypes = ["image", "pdf"];

    const { fileType } = document;

    if (document && supportedFileTypes.includes(fileType)) {
      this.categorizeDocument(document, link.dropzoneRef);
    }
  }

  categorizeDocument(document, category) {
    this.props.saveDocument(document, category);
  }

  isEmpty(obj) {
    return Object.keys(obj).length != 0;
  }

  render() {
    const {
      messages,
      isLoading,
      modalShown,
      currentIndex,
      files,
      loadingMessage,
      isLoadingInitial,
      grouped,
      sidebarShown,
      categoryFilter,
      category,
      documents,
      documentsFiles,
      currentDocumentsIndex,
      documentPreviewShown,
    } = this.state;

    const { imageUrl, threadName } = this.props;

    const imageSrc = imageUrl || require("../../../assets/images/group-default.png");

    return (
      <div className="d-flex" id="wrapper">
        <div id="page-content-wrapper">
          <div className="Conversation-Header" style={this.headerStyles}>
            <div className="patient-doc-details">
              <img src={imageSrc} alt="" className="header-img rounded-circle" />
              <p className="Thread-Name">{threadName}</p>
            </div>
            {/* <button onClick={() => this.toggleSidebar()}>Toggle</button> */}
          </div>

          <div style={{ margin: "15px 90px 0px 15px" }}>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb" style={{ display: "flex" }}>
                <li className={categoryFilter === "" ? "breadcrumb-item active" : "breadcrumb-item"}>
                  <a onClick={() => this.handleFilter("")} href="#!">
                    All Files
                  </a>
                </li>
                {categoryFilter != "" ? (
                  <li className="breadcrumb-item active" aria-current="page">
                    {category.label}
                  </li>
                ) : (
                  ""
                )}
                {/* <button
                  className="btn btn-primary btn-sm"
                  style={{
                    marginLeft: "auto",
                    width: "150px",
                    borderRadius: "10px"
                  }}
                  onClick={() => this.handleTagging()}
                >
                  <span className="fa fa-tags pr-2"></span> 
                  Categorize Docs
                </button> */}
              </ol>
            </nav>
          </div>

          {this.state.isTagging && (
            <div
              className="breadcrumb animate-fade"
              style={{
                margin: "10px 90px 15px 15px",
                padding: "10px",
                backgroundColor: "#ADD8E6",
                color: "#2194f3",
              }}
            >
              <span>
                <span className="fa fa-info-circle pr-2"></span>
                Drag documents to category to tagged them
              </span>
            </div>
          )}

          <div id="main-row-wrapper" className="main-row-wrapper" style={{ marginRight: "65px" }}>
            {/* {!isLoading ? ( */}
            {this.isEmpty(grouped) ? (
              // <div className="document-item-container">
              //   <Documents
              //     items={documents}
              //     onSelect={(objectId) => this.handleOpenDocument(objectId)}
              //   />
              // </div>
              <Groups
                items={grouped}
                onSelect={(objectId) => this.openModal(objectId)}
                onDrag={() => this.handleDrag()}
                handleMouseDown={(e) => this.handleMouseDown(e)}
                isTagging={this.state.isTagging}
                links={this.links}
                handleTaggingDocs={(e, ref, message) => this.handleTaggingDocs(e, ref, message)}
                isloading={this.state.isloading}
                categoryFilter={this.state.categoryFilter}
              />
            ) : (
              <div align="center" className="text-empty">
                No records
              </div>
            )}
            {/* // ) : (
            //   ""
            // )} */}
            {!isLoading && this.state.hasMore ? (
              <div className="d-flex justify-content-center mb-3">
                <button className="btn btn-primary" onClick={(e) => this.loadMore()}>
                  <i className="fas fa-chevron-double-down mr-1"></i>
                  Load more
                </button>
              </div>
            ) : (
              ""
            )}
          </div>

          {isLoading ? (
            <div style={{ height: "70px" }} align="center">
              <Spinner top="50" />
            </div>
          ) : (
            ""
          )}

          {!isLoading && !messages.length ? <span>No files</span> : ""}

          <FilePreview2
            onSelect={(link) => this.handleSelectDocument(link)}
            links={this.links}
            documentName="Document name"
            images={files}
            currentIndex={currentIndex}
            isOpen={modalShown}
            modalClose={this.handleModalClose}
          />
          {documentPreviewShown ? (
            <FilePreview
              documentName={"Document"}
              images={documentsFiles}
              currentIndex={currentDocumentsIndex}
              isOpen={documentPreviewShown}
              modalClose={() => this.closeDocumentPreview()}
            />
          ) : (
            ""
          )}
          <Loader isLoading={isLoadingInitial} message={loadingMessage} />
          <ToastContainer />
        </div>

        <div
          className="bg-light border-right"
          id="sidebar-wrapper"
          style={{
            height: "100%",
            position: "absolute",
            right: "0",
            zIndex: "1",
          }}
        >
          <Sidebar
            links={this.links}
            filter={categoryFilter}
            onFilter={(filter) => this.handleFilter(filter)}
            onDocumentClose={() => this.closeDocument()}
            onDocumentOpen={() => this.openDocument()}
            activeThread={this.props.activeThread}
            documentIsOpen={sidebarShown}
            closeDocument={this.clodeDocument}
            threadId={this.state.threadId}
            attachmentId={this.state.attachmentId}
            isTagging={this.state.isTagging}
          />
        </div>
      </div>
    );
  }
}

function Groups(props) {
  const { items = {}, isDragging = false } = props;
  const allKeys = Object.keys(items);

  return allKeys.map((monthYear, index) => {
    const messages = items[monthYear];

    return (
      <div key={index}>
        <div style={{ marginLeft: "15px" }}>
          <h3>{monthYear}</h3>
        </div>
        <div className="document-item-container">
          <Messages
            key={monthYear}
            items={messages}
            onSelect={(objectId) => props.onSelect(objectId)}
            onDrag={props.onDrag}
            handleMouseDown={(e) => props.handleMouseDown(e)}
            isTagging={props.isTagging}
            links={props.links}
            handleTaggingDocs={(e, ref, message) => props.handleTaggingDocs(e, ref, message)}
            isloading={props.isloading}
            categoryFilter={props.categoryFilter}
          />
        </div>
      </div>
    );
  });
}

function Messages(props) {
  const { items, links } = props;

  function getFileExtention(filename) {
    return filename.substr((~-filename.lastIndexOf(".") >>> 0) + 2);
  }

  function getPdfThumbnail(thumbnail) {
    if (!thumbnail) return "";

    const url = thumbnail.url;

    const ext = getFileExtention(url).toLowerCase();

    if (ext === "pdf") return "";

    return url;
  }

  return items.map((message, index) => {
    const { file, createdAt } = message;

    const formattedDate = message.attachment
      ? util.fromThemDate(message.attachment.createdAt)
      : util.fromThemDate(createdAt);

    const objectId = message.attachment ? message.attachment.objectId : message.objectId;

    const isPDF = message.fileType === "pdf";

    const thePreviewContent = <Thumbnail file={message} />;

    const thePreviewContent2 = <Thumbnail file={message} />;

    if (message.emrType != undefined) {
      links.map((link, index) => {
        if (link.dropzoneRef === message.emrType) {
          message.category = link.label;
          message.imageSrc = link.imageSrc;
        }
      });
    }

    return (
      <div key={index} className="document-item">
        <Draggable data={message} willDrag={props.onDrag}>
          <div
            className="img-thumbnail"
            data-tip
            data-for={"tooltip_" + objectId}
            style={{ position: "relative" }}
            // onMouseDown={() => props.handleMouseDown(message)}
          >
            {props.categoryFilter == "" && (
              <>
                <a
                  className={`overlay-tagg ${message.emrType != undefined ? "disabled" : ""}`}
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ backgroundColor: `${message.emrType != undefined ? "#ADD8E6" : ""}` }}
                >
                  <div className="overlay-item">
                    {props.isloading ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : message.emrType != undefined ? (
                      <img style={{ width: "20px", height: "20px" }} title={message.category} src={message.imageSrc} />
                    ) : (
                      <i className="fa fa-tags"></i>
                    )}
                  </div>
                </a>
                <div
                  style={{ boxShadow: "0px 4px 8px 0px #888888" }}
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton"
                >
                  <h6 className="dropdown-header">Tag Document</h6>
                  {props.links.map((link, index) => (
                    <a
                      key={index}
                      onClick={(e) => {
                        props.handleTaggingDocs(e, link.dropzoneRef, message);
                        message.emrType = link.dropzoneRef;
                      }}
                      className="dropdown-item"
                      href="#!"
                    >
                      <img
                        data-toggle="tooltip"
                        data-placement="top"
                        data-html="true"
                        title=""
                        data-original-title={link.label}
                        style={{ height: "15px", marginRight: "5px" }}
                        src={link.imageSrc}
                      />
                      {link.label}
                    </a>
                  ))}
                </div>
              </>
            )}
            <div className="thumbnail-wrapper-files" align="center">
              {thePreviewContent}

              {/* {!props.isTagging && */}
              {
                <>
                  <div className="overlay">
                    <a className="overlay-item" onClick={(e) => props.onSelect(objectId)}>
                      <i className="fa fa-eye"></i>
                      <span>View</span>
                    </a>
                    {isPDF && (
                      <a className="overlay-item" href={file.url} target="_blank">
                        <i className="fa fa-file-pdf"></i>
                        <span>Open</span>
                      </a>
                    )}
                  </div>
                </>
              }
            </div>
          </div>
        </Draggable>

        <p className="file-thumbnail-caption">
          <span style={{ fontSize: "12px", fontWeight: "bold" }} className="hc-primary-text">
            {formattedDate}
          </span>
        </p>
        <ReactTooltip
          id={"tooltip_" + objectId}
          type="dark"
          effect="solid"
          place="right"
          data-offset="left"
          // data-iscapture='true'
          data-scroll-hide="false"
        >
          <div
            style={{
              height: "auto",
              maxHeight: "600px",
              maxWidth: "400px",
              width: "auto",
            }}
          >
            {thePreviewContent2}
          </div>
        </ReactTooltip>
      </div>
    );
  });
}

function Documents(props) {
  const { items = [] } = props;

  const documents = items.map((item, i) => {
    if (item.photo) {
      if (item.photo.url) {
        let fileExt = util.getFileExtension(item.photo.name);
        const isPDF = fileExt === "pdf";
        const imgUrl = item.photo.url;
        const formattedDate = util.fromThemDate(item.createdAt);

        return (
          <div className="document-item">
            <div className="img-thumbnail">
              <div className="thumbnail-wrapper-files" align="center">
                {isPDF ? (
                  <Document
                    file={imgUrl}
                    loading={
                      <div>
                        <i className="fas fa-circle-notch fa-spin"></i> Loading PDF
                      </div>
                    }
                  >
                    <Page pageNumber={1} className="react-pdf__Page-canvas-container" />
                  </Document>
                ) : (
                  <img src={imgUrl} className="img-thumbnail-files" alt="Image" />
                )}

                <a className="overlay" onClick={() => props.onSelect(item.objectId)}>
                  <span style={{ color: "white", fontWeight: "bold" }}>
                    <i className="fa fa-eye mr-2"></i>
                    View
                  </span>
                </a>
              </div>
            </div>
            <p className="file-thumbnail-caption">
              <span style={{ fontSize: "12px", fontWeight: "bold" }} className="hc-primary-text">
                {formattedDate}
              </span>
            </p>
          </div>
        );
      }
    }
    return null;
  });

  return documents;
}

function FileThumbnail(props) {
  return (
    <div>
      <div className="img-thumbnail">
        <div className="thumbnail-wrapper-files" align="center">
          {props.children}
          <a className="overlay">
            <span style={{ color: "white", fontWeight: "bold" }}>
              <i className="fa fa-eye mr-2"></i>
              View
            </span>
          </a>
        </div>
      </div>
      <p className="file-thumbnail-caption">
        <span style={{ fontSize: "12px", fontWeight: "bold" }} className="hc-primary-text">
          Caption
        </span>
      </p>
    </div>
  );
}

function PdfThumb({ thumbUrl }) {
  return thumbUrl ? <ImageLoad openLightbox={() => {}} imageURL={thumbUrl} /> : <ImagePlaceholder type="pdf" />;
}

function Thumbnail({ file = {} }) {
  /*  
    For displaying thumbnails, we have 2 cases only
    1.) Thumbnail is present: Display the thumbnail
    2.) No thumbnail: Display appropriate icon

    Exception: Images may not have thumbnail, but we can display them
  */
  const thumbnail = file.attachment
    ? file.attachment.fileType === "image"
      ? file.attachment.thumbNail || file.attachment.file
      : file.attachment.thumbNail
    : file.fileType === "image"
    ? file.thumbnail || file.file
    : file.thumbnail;

  return (
    <div className="file-thumbnail">
      {thumbnail ? <ThumbnailImage src={thumbnail.url} /> : <ImagePlaceholder type={file.fileType} />}
    </div>
  );
}

function ThumbnailImage({ src = "" }) {
  return <img src={src} alt="image" className="img-centered" />;
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  fetchDocuments,
  saveDocument,
  fetchFilteredDocuments,
  categorizeDocument,
  getFilesv3,
})(FilesWindow);
